module.exports = "<ng-container *ngIf=\"item; let row\">\n    <div class=\"playlist-row {{layout}}\">\n        <div class=\"headline\">\n            <h3 class=\"title\">{{playListLabel}}</h3>\n            <div class=\"title-marker\" [attr.data-type]=\"(row|meta).obj_type\"></div>\n        </div>\n        <carousel-row [item]=\"row\" [items]=\"row.data\" [config]=\"carouselConfig\"></carousel-row>\n    </div>\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/video-playlist/playlist-row/playlist-row.template.html
// module id = 815
// module chunks = 2